/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/destructuring-assignment */
import { Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Yup from "yup";
import { Button, InputGroup, Modal } from "react-bootstrap";
import eye_visible from "../../assets/images/icons/eye_visible.svg";
import eye_Invisible from "../../assets/images/icons/eye_Invisible.svg";
import { loginModalAction } from "../../containers/login/actions";
import { regex } from "../../utils/regex";

const validationSchema = Yup.object({
  email: Yup.string()
    .required("email Can not be empty")
    .email("email must be a valid email address")
    .matches(regex.email, "email must be a valid email address"),
  password: Yup.string().required("password can not be empty").min(8),
});

function LoginModal(props) {
  const initialState = {
    email: "",
    password: "",
  };
  const [state, setState] = useState({
    show_pass: false,
  });
  const handleSubmit = (values, actions) => {
    const data = {
      email: values.email,
      password: values.password,
    };
    props.loginModalAction(data, actions, props.history, props.modal);
  };

  return (
    <Modal show={props.isOpen} onHide={props.onClosed}>
      <Modal.Header closeButton>
        <Modal.Title className="h6">Log In</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Login and begin learning. We’re excited to be with you on this journey.</p>
        <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema}>
          {({ values, handleChange, handleBlur, touched, errors }) => {
            return (
              <Form className="loginForm p-4">
                <div className="mb-2">
                  <InputGroup>
                    <input
                      size="lg"
                      id="email"
                      name="email"
                      className="form-control"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="E-mail*"
                    />
                    <InputGroup.Text>
                      <i className="fa-regular fa-envelope fa-fw" aria-hidden="true" />
                    </InputGroup.Text>
                  </InputGroup>
                  {touched.email && errors.email && <div className="errorMessage">{errors.email}</div>}
                </div>

                <div className="mb-2">
                  <InputGroup>
                    <Field
                      className="form-control"
                      id="password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Password*"
                      icons={!state.show_pass ? eye_visible : eye_Invisible}
                      type={state.show_pass ? "text" : "password"}
                      showPassHandler={() =>
                        setState({
                          ...state,
                          show_pass: !state.show_pass,
                        })
                      }
                    />
                    <InputGroup.Text
                      className="cursor-pointer"
                      onClick={() =>
                        setState({
                          ...state,
                          show_pass: !state.show_pass,
                        })
                      }
                    >
                      <i className={`fa-regular fa-fw ${state.show_pass ? "fa-eye-slash" : "fa-eye"}`} />
                    </InputGroup.Text>
                  </InputGroup>
                  {touched.password && errors.password && <div className="errorMessage">{errors.password}</div>}
                </div>

                <div className="d-flex justify-content-between">
                  <a className="forgotPassword" style={{ color: "#8170EA" }} href="/signup">
                    Not a member yet? Sign Up Here
                  </a>
                  <a className="forgotPassword" style={{ color: "#8170EA" }} href="/forget-password">
                    Forget your password?
                  </a>
                </div>
                <div className="text-end">
                  <Button type="submit" variant="success" className="my-2">
                    Log In Now
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
export default connect(null, { loginModalAction })(withRouter(LoginModal));
